// Approved consent wording; acceptance enabled after implementation checks.
export const analyticsNotice = Object.freeze({
  approved: true,
  version: 'analytics-2026-10-20-v2',
  text: `Aiutaci a migliorare StirUp
Con il tuo consenso, utilizziamo Google Analytics per capire come vengono utilizzate le funzionalità di StirUp, ad esempio ricerca dei servizi, consultazione dei listini, carrello e acquisti.
Raccogliamo informazioni sull'utilizzo dell'app e identificativi tecnici del browser o dispositivo. Non inviamo a Google Analytics nomi, email, indirizzi o contenuti dei moduli.
Utilizziamo queste statistiche per migliorare il servizio, non per finalità pubblicitarie.
La scelta è facoltativa: puoi rifiutare o revocare il consenso in qualsiasi momento dalle Preferenze statistiche, senza limitazioni nell'utilizzo di StirUp.
Questa scelta è separata dalle preferenze marketing e dalle notifiche e riguarda il browser o l'installazione dell'app che stai utilizzando.
Per maggiori informazioni consulta l'Informativa Privacy, sezione Statistiche e Google Analytics.`,
});
